import {InputProps} from '@material-ui/core/Input';
import {matchPhoneNumber, PhoneNumber, ValidPhoneNumber} from 'Core/models/PhoneNumber';
import {constant} from 'fp-ts/lib/function';
import React, {useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import {maskPhoneNumber, unmaskPhoneNumber as unMaskPhoneNumber} from 'Shared/utilities/phoneNumberMasker';

type PhoneInputProps = {
  InputProps?: InputProps;
  className?: string;
  disabled?: boolean;
  onChange: (value: PhoneNumber) => void;
  phoneNumber: PhoneNumber;
  errors?: string[];
  label?: string;
};

export const PhoneInput = (props: PhoneInputProps) => {
  const [hasBlurredPhone, setHasBlurredPhone] = useState(false);

  return (
    <ValidatableTextField
      InputProps={props.InputProps}
      className={props.className}
      placeholder="(XXX) XXX-XXXX"
      disabled={props.disabled}
      value={maskPhoneNumber(props.phoneNumber.phoneNumber)}
      showErrors={errors => hasBlurredPhone && errors.value.length > 0}
      inputProps={{
        maxLength: '14',
      }}
      errors={Errors.standardErrors({
        value: [
          ...(props.errors || []),
          ...matchPhoneNumber(props.phoneNumber, {
            InvalidPhoneNumber: invalid => [invalid.validationError],
            UnvalidatedPhoneNumber: constant([]),
            ValidPhoneNumber: constant([]),
          }),
        ],
      })}
      onChange={phoneNumber => props.onChange(ValidPhoneNumber.create(unMaskPhoneNumber(phoneNumber)))}
      onBlur={() => setHasBlurredPhone(true)}
      label={props.label || 'Phone Number'}
    />
  );
};

export default PhoneInput;
